export default __webpack_public_path__ + "static/media/empty-cart.88bfbd37.png";